import Base from "../../../base";
import ConfigService from "../../../../services/running/config";
import Form from "../../../layout/form";
import { Fragment } from 'react';
import style from './index.module.css';
import $ from 'jquery';

class ConfigList extends Base
{
    boot() {
        this.state = {
            model:{},
            origin:[],
            fields:{}
        }
    }

    service() {
        return ConfigService;
    }

    load() {
        this.server.getList(data => {
            let model = {},
                fields = {};
            for(var k of data) {
                model[k.type] = k.value;
                fields[k.type] = {
                    name:k.name,
                    type:k.formType || 'text',
                    data:JSON.parse(k.params || "[]"),
                    tip:k.tip || '',
                    title:k.title || ''
                }
            }
            this.setState({
                origin:data,
                model:model,
                fields: fields
            })
        })
    }

    componentDidMount() {
        /* global layer */
        this.load();
    }

    render() {
        return (
            <Fragment>
                <Form
                    model={this.state.model}
                    fields={this.state.fields}
                    labelStyle={{
                        whiteSpace:'nowrap',
                        overflow:'hidden',
                        textOverflow:'ellipsis'
                    }}
                />
                <div onClick={e => this.submit()} className={'layui-btn layui-btn-primary layui-border-blue '+style.btn}>保存</div>
            </Fragment>
        );
    }

    submit() {
        let model = {};
        $('.layui-form').find('input,textarea').each(function() {
            let name = $(this).attr('name');
            if (name) {
                model[name] = $(this).val();
            }
        })
        $('.layui-form').find('select').each(function() {
            let name = $(this).attr('name');
            if (name) {
                model[name] = $(this).val();
            }
        })
        let changes = [];
        for (let k of this.state.origin) {
            if ((model[k.type] || '') !== (k.value || '')) {
                changes.push({type:k.type,value:model[k.type]});
            }
        }

        if (changes.length) {
            for(let k in changes) {
                this.server.save(changes[k], () => {
                    if (Number(k) === changes.length - 1) {
                        layer.msg('保存成功!');
                        this.load();
                    }
                }, (msg) => {
                    layer.msg(msg);
                })
            }
        } else {
            layer.msg('没有任何修改!');
        }
    }
}
export default ConfigList;
